import { CircularProgress as MaterialCircularProgress } from "@rmwc/circular-progress";
import * as React from "react";
// eslint-disable-next-line
require("@rmwc/circular-progress/circular-progress.css");
export var CircularProgress = function(props) {
    var className = props.className, progress = props.progress, size = props.size, style = props.style, title = props.title;
    return /*#__PURE__*/ React.createElement(MaterialCircularProgress, {
        className: className,
        progress: progress,
        size: size,
        style: style,
        title: title
    });
};
